import anime from 'animejs/lib/anime.es.js';
import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
Swiper.use([Pagination, Navigation, Lazy]);

const initAboutSlider = () => {
  const sliderContainer = document.querySelector('.about__swiper'),
    chips = document.querySelectorAll('.about__img-block');

  new Swiper(sliderContainer, {
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
    },
    navigation: {
      nextEl: '.about__next',
      prevEl: '.about__prev',
      disabledClass: 'about__disable',
    },
    pagination: {
      el: '.about__pagination',
      bulletActiveClass: 'active',
    },
    on: {
      init: function () {
        [...chips].map((item) => {
          [...item.children].map((it) => {
            it.style.transform = 'translateY(250px)';
            it.style.opacity = '0';
          });
          aboutAnimation(item);
        });
      },
      activeIndexChange: function () {
        changeSlide(this.activeIndex);
      },
    },
  });

  //Смена контента, при смене слайда
  function changeSlide(index) {
    [...chips].map((item, idx) => {
      item.classList.remove('active');
      idx == index ? item.classList.add('active') : '';

      if (idx == index) {
        [...item.children].map((it) => {
          it.style.transform = 'translateY(250px)';
          it.style.opacity = '0';
        });
        aboutAnimation(item);
      }
    });
  }

  function aboutAnimation(item) {
    if (window.innerWidth >= 1024) {
      anime({
        targets: item.children[0],
        opacity: 1,
        keyframes: [{ translateY: -50 }, { translateY: 0 }],
        duration: 1500,
        easing: 'easeOutElastic(1, .8)',
      });
      anime({
        targets: item.children[1],
        opacity: 1,
        keyframes: [{ translateY: -50 }, { translateY: 0 }],
        delay: 300,
        duration: 1500,
        easing: 'easeOutElastic(1, .8)',
      });
      anime({
        targets: [item.children[2], item.children[3], item.children[4]],
        opacity: 1,
        keyframes: [{ translateY: -50 }, { translateY: 0 }],
        delay: 600,
        duration: 1500,
        easing: 'easeOutElastic(1, .8)',
      });
    } else {
      anime({
        targets: item.children[5],
        opacity: 1,
        keyframes: [{ translateY: -50 }, { translateY: 0 }],
        duration: 1500,
        easing: 'easeOutElastic(1, .8)',
      });
    }
  }
};

export default initAboutSlider;
